import { Button, Flex } from "antd";
import { useState } from "react";
import useSaveTransaction from "../../../functions/Transaction/saveTransaction";
import QRReceiptModal from "./QRReceiptModal";

export default function Receipt(props) {
  const {
    plates,
    onPaymentSuccessReset,
    transactionInfo,
    setTransactionInfo,
    isDisableCompleteTransactionButton = false,
    setExtraChargesOptions,
  } = props;
  const [isSaved, setIsSaved] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onNoReceiptButtonClicked = () => {
    if (!isSaved) {
      //Save transaction into database
      callSaveTransaction(true);
    } else {
      reset();
    }
  };

  const { saveTransaction } = useSaveTransaction();

  const callSaveTransaction = (reset_on_save) =>
    saveTransaction(
      plates,
      transactionInfo,
      reset_on_save,
      onTransactionSuccess,
      onTransactionFailed
    );

  const onTransactionSuccess = (reset_on_save) => {
    setIsSaved(true);
    if (reset_on_save) {
      reset();
    }
  };
  const onTransactionFailed = () => {};

  function reset() {
    setTransactionInfo(null);
    setIsSaved(false);
    onPaymentSuccessReset();
    setExtraChargesOptions((prev) => ({
      ...prev,
      takeaway_fee: false,
    }));
  }

  return (
    <>
      <div style={{ height: "100%", width: "100%" }}>
        <Flex
          gap="middle"
          justify="space-evenly"
          align="center"
          vertical
          style={{ height: "100%", width: "100%" }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "3vw",
            }}
          >
            {transactionInfo?.invoice_no
              ? `Invoice No: ${transactionInfo.invoice_no}`
              : "Generating Invoice No."}
            <br />
            Do you need a receipt?
          </div>
          <Flex style={{ width: "100%" }} justify="space-evenly" align="center">
            <Button
              className="no-receipt-btn"
              onClick={onNoReceiptButtonClicked}
              disabled={isDisableCompleteTransactionButton}
            >
              No
            </Button>
            <Button
              className="get-receipt-btn"
              onClick={() => setIsModalOpen(true)}
              disabled={isDisableCompleteTransactionButton}
            >
              Yes
            </Button>
          </Flex>
        </Flex>
      </div>
      <QRReceiptModal
        isModalOpen={isModalOpen}
        invoiceNumber={transactionInfo?.invoice_no}
        onNoReceiptButtonClicked={onNoReceiptButtonClicked}
      />
    </>
  );
}
